import countries from 'i18n-iso-countries';
import en from 'i18n-iso-countries/langs/en.json';
import de from 'i18n-iso-countries/langs/de.json';

countries.registerLocale(en);
countries.registerLocale(de);

export const getCountryOptions = (lang: 'en' | 'de') => {
  const names = countries.getNames(lang);

  return Object.entries(names).map(([code, name]) => ({
    name: name,
    ISO2: code,
  }));
};
